namespace GeniuzPOS.AdvPromo {
    export interface Adv05ItemDetailsForm {
        PmId: Serenity.StringEditor;
        StartPromoDate: Serenity.DateEditor;
        EndPromoDate: Serenity.DateEditor;
        PmTypeDesc: Serenity.StringEditor;
        PmType: Serenity.IntegerEditor;
        PmGroupId: Serenity.StringEditor;
        PmExtCode: Serenity.StringEditor;
        PmDesc: Serenity.StringEditor;
        ListFg: Serenity.IntegerEditor;
        PPtype: Serenity.IntegerEditor;
        PmStepNo: Serenity.IntegerEditor;
        ItemType: Serenity.IntegerEditor;
        AssortFg: Serenity.IntegerEditor;
        SkuCode: Serenity.StringEditor;
        PluCode: Serenity.StringEditor;
        PluShortDesc: Serenity.StringEditor;
        StyleCode: Serenity.StringEditor;
        StyleName: Serenity.StringEditor;
        CatCode: Serenity.StringEditor;
        CatName: Serenity.StringEditor;
        SubCat1Code: Serenity.StringEditor;
        SubCat1Name: Serenity.StringEditor;
        SubCat2Code: Serenity.StringEditor;
        SubCat2Name: Serenity.StringEditor;
        BrandCode: Serenity.StringEditor;
        BrandName: Serenity.StringEditor;
        SupplCode: Serenity.StringEditor;
        SupplName: Serenity.StringEditor;
        Normalprice: Serenity.DecimalEditor;
        PromotionPrice: Serenity.StringEditor;
        DiscPc: Serenity.StringEditor;
        Remark: Serenity.StringEditor;
    }

    export class Adv05ItemDetailsForm extends Serenity.PrefixedContext {
        static formKey = 'AdvPromo.Adv05ItemDetails';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!Adv05ItemDetailsForm.init)  {
                Adv05ItemDetailsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DateEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.DecimalEditor;

                Q.initFormType(Adv05ItemDetailsForm, [
                    'PmId', w0,
                    'StartPromoDate', w1,
                    'EndPromoDate', w1,
                    'PmTypeDesc', w0,
                    'PmType', w2,
                    'PmGroupId', w0,
                    'PmExtCode', w0,
                    'PmDesc', w0,
                    'ListFg', w2,
                    'PPtype', w2,
                    'PmStepNo', w2,
                    'ItemType', w2,
                    'AssortFg', w2,
                    'SkuCode', w0,
                    'PluCode', w0,
                    'PluShortDesc', w0,
                    'StyleCode', w0,
                    'StyleName', w0,
                    'CatCode', w0,
                    'CatName', w0,
                    'SubCat1Code', w0,
                    'SubCat1Name', w0,
                    'SubCat2Code', w0,
                    'SubCat2Name', w0,
                    'BrandCode', w0,
                    'BrandName', w0,
                    'SupplCode', w0,
                    'SupplName', w0,
                    'Normalprice', w3,
                    'PromotionPrice', w0,
                    'DiscPc', w0,
                    'Remark', w0
                ]);
            }
        }
    }
}
